import { useIntl } from 'react-intl'

import { useFormatShortDate } from '@webapp/core/components/FormattedDate/useFormatShortDate'
import messages from './messages'

export const SECOND_MS = 1000
export const MINUTE_MS = 60 * SECOND_MS
export const HOUR_MS = 60 * MINUTE_MS
export const DAY_MS = 24 * HOUR_MS
export const MINUTES_PER_HOUR = 60
export const HOURS_PER_DAY = 24
export const DAYS_CUTOFF = 7

export function useFormatRelativeTime() {
  const intl = useIntl()
  const formatShortDate = useFormatShortDate()

  return (date: Date): string => {
    const diffMs = Date.now() - date.getTime()

    if (diffMs < 0) return formatShortDate(date)

    if (diffMs < MINUTE_MS) return intl.formatMessage(messages.justNow)

    const minutes = Math.floor(diffMs / MINUTE_MS)
    if (minutes < MINUTES_PER_HOUR) {
      return intl.formatMessage(messages.minutesAgo, { count: minutes })
    }

    const hours = Math.floor(diffMs / HOUR_MS)
    if (hours < HOURS_PER_DAY) {
      return intl.formatMessage(messages.hoursAgo, { count: hours })
    }

    const days = Math.floor(diffMs / DAY_MS)
    if (days <= DAYS_CUTOFF) {
      return intl.formatMessage(messages.daysAgo, { count: days })
    }

    return formatShortDate(date)
  }
}
